// import { useMutation, useQuery } from "@tanstack/react-query";
import {  useQuery } from '@tanstack/react-query';
import { useStoreChoiceGroupApi } from '../../hooks/useStoreChoiceGroupApi';

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
  storeId?: string;
};
export const useStoreChoiceGroup = (queryParams: Params) => {

  const { getStoreChoiceGroup } = useStoreChoiceGroupApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getChoiceGroup',queryParams],
    queryFn: () => {
      return getStoreChoiceGroup(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};


